import React from 'react';

const modernized: React.FC = () => (
  <svg className="diamond diamond--modernized" viewBox="0 0 87.03 87.03">
    <path
      fill="white"
      d="M43.52 0L0 43.52 43.52 87 87 43.52zm16.33 54.66a2.05 2.05 0 0 0 1.2 1.14 7.76 7.76 0 0 0 2.83.4v2H49.16v-2a7.72 7.72 0 0 0 2.8-.38 1.94 1.94 0 0 0 1.15-1.11 5.82 5.82 0 0 0 .27-2V34.34L42.3 58.19H41L29.75 34.34V51.8a16.19 16.19 0 0 0 .1 2.12 2.53 2.53 0 0 0 .5 1.26 2.35 2.35 0 0 0 1.26.77 9.36 9.36 0 0 0 2.4.25v2H23.15v-2a8.8 8.8 0 0 0 2.41-.26 2.45 2.45 0 0 0 1.25-.78 2.56 2.56 0 0 0 .48-1.25c.05-.48.08-1.18.08-2.11V35.18a13 13 0 0 0-.19-2.68 1.82 1.82 0 0 0-1.07-1.24 7.24 7.24 0 0 0-3-.43v-2h10.77l9.74 20.71 9.76-20.71h10.5v2c-1.8 0-3 .27-3.5.79a3.75 3.75 0 0 0-.79 2.68v18.43a6 6 0 0 0 .26 1.93z"
    />
  </svg>
);

const updated: React.FC = () => (
  <svg className="diamond diamond--updated" viewBox="0 0 87.03 87.03">
    <path
      fill="white"
      d="M43.52 0L0 43.52 43.52 87 87 43.52zm13.19 31a1.89 1.89 0 0 0-1.05 1.3 12.39 12.39 0 0 0-.2 2.59v10.84a37.71 37.71 0 0 1-.2 4.49 8.37 8.37 0 0 1-1.1 3 8.62 8.62 0 0 1-4.6 4.08 15.92 15.92 0 0 1-5.68 1.12 17.29 17.29 0 0 1-4.14-.53 13 13 0 0 1-4-1.74A7.75 7.75 0 0 1 33 53a11 11 0 0 1-.8-2.17 10.78 10.78 0 0 1-.34-2.06c0-.64-.05-1.48-.05-2.52L31.74 34a3.9 3.9 0 0 0-.74-2.66c-.5-.52-1.67-.78-3.5-.78v-2h14.8v2a7.94 7.94 0 0 0-2.81.38A2 2 0 0 0 38.28 32a5.58 5.58 0 0 0-.28 2v12.25a26.42 26.42 0 0 0 .18 3.3 12 12 0 0 0 .57 2.45 5.88 5.88 0 0 0 2.5 2.8 7.47 7.47 0 0 0 3.89 1.05 8.46 8.46 0 0 0 4.23-1.11 6.14 6.14 0 0 0 2.72-2.89 10.64 10.64 0 0 0 .79-2.85 29.94 29.94 0 0 0 .18-3.54V34.91a18.06 18.06 0 0 0-.06-2.12 2.56 2.56 0 0 0-.47-1.22 2.27 2.27 0 0 0-1.29-.77 10.08 10.08 0 0 0-2.48-.24v-2h10.8v2a6.25 6.25 0 0 0-2.85.44z"
    />
  </svg>
);

const original: React.FC = () => (
  <svg className="diamond diamond--original" viewBox="0 0 87.03 87.03">
    <path
      fill="white"
      d="M43.52 0L0 43.52 43.52 87 87 43.52zm8.84 56.61a17.71 17.71 0 0 1-8.82 2.11 18.71 18.71 0 0 1-7.32-1.34 14.39 14.39 0 0 1-5.16-3.6 15 15 0 0 1-3-4.93A15.66 15.66 0 0 1 29 36.06a14.11 14.11 0 0 1 5.54-5.62 17.47 17.47 0 0 1 8.85-2.13 18.7 18.7 0 0 1 8 1.54 13.79 13.79 0 0 1 5.13 3.87 15.3 15.3 0 0 1 2.63 4.9 16.82 16.82 0 0 1 .79 4.88A15.43 15.43 0 0 1 58 51a14.26 14.26 0 0 1-5.64 5.61z"
    />
    <path
      fill="white"
      d="M51 34.75a7.8 7.8 0 0 0-2.9-2.83 9 9 0 0 0-4.54-1.05 8.43 8.43 0 0 0-5.81 1.85 9.17 9.17 0 0 0-2.84 4.63 23.26 23.26 0 0 0-.74 6.07 31.13 31.13 0 0 0 .23 3.78 14.19 14.19 0 0 0 1.15 4 8.43 8.43 0 0 0 2.9 3.49 8.71 8.71 0 0 0 5.15 1.41 8.36 8.36 0 0 0 5.1-1.46 8.62 8.62 0 0 0 2.85-3.57 14.68 14.68 0 0 0 1.13-4 31.5 31.5 0 0 0 .23-3.65 25 25 0 0 0-.43-4.68A12.15 12.15 0 0 0 51 34.75z"
    />
  </svg>
);

const spanish: React.FC = () => (
  <svg className="diamond diamond--spanish" viewBox="0 0 87.03 87.03">
    <path
      fill="white"
      d="M43.52 0L0 43.52 43.52 87 87 43.52zM30.33 58.19v-2q2.7 0 3.48-.78a3.74 3.74 0 0 0 .78-2.69V34.3a6 6 0 0 0-.25-2 2 2 0 0 0-1.17-1.11 7.67 7.67 0 0 0-2.84-.4v-2h24.34l.39 7.62h-2a10 10 0 0 0-1.55-3.62 3.57 3.57 0 0 0-2-1.35 16.37 16.37 0 0 0-3.28-.25h-5.45v10.42h3a7.32 7.32 0 0 0 2.3-.27 1.72 1.72 0 0 0 1.06-1 8.38 8.38 0 0 0 .41-2.38h2.08v9.76h-2a7.14 7.14 0 0 0-.44-2.39 1.84 1.84 0 0 0-1.09-1 7.55 7.55 0 0 0-2.29-.33h-3v6.91c0 1.15 0 2 .08 2.53a2.81 2.81 0 0 0 .47 1.33 2.17 2.17 0 0 0 1.23.77 9.59 9.59 0 0 0 2.44.23h2.36a10.58 10.58 0 0 0 2.84-.37 5.61 5.61 0 0 0 2.65-1.95 10.22 10.22 0 0 0 1.82-4.92h2l-.23 9.65z"
    />
  </svg>
);

const Diamonds: {
  original: React.FC;
  modernized: React.FC;
  updated: React.FC;
  spanish: React.FC;
} = { original, modernized, updated, spanish };

export default Diamonds;
